import { render, staticRenderFns } from "./umenuView.vue?vue&type=template&id=1ee06d76&scoped=true"
import script from "./umenuView.vue?vue&type=script&lang=js"
export * from "./umenuView.vue?vue&type=script&lang=js"
import style0 from "./umenuView.vue?vue&type=style&index=0&id=1ee06d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee06d76",
  null
  
)

export default component.exports